import { FlowbiteDropdownTheme } from 'flowbite-react';

// Custom Flowbite Dropdown Theme
export const dropdownTheme: FlowbiteDropdownTheme = {
    arrowIcon: 'ml-2 h-4 w-4',
    content: 'py-1 focus:outline-none p-0',
    floating: {
        animation: 'transition-opacity',
        arrow: {
            base: 'absolute z-10 h-2 w-2 rotate-45',
            style: {
                dark: 'bg-system-surface',
                light: 'bg-system-surface',
                auto: 'bg-system-surface ',
            },
            placement: '-4px',
        },
        base: 'z-10 w-fit rounded divide-y list-none focus:outline-none focus:ring-0',
        content: '',
        divider: 'my-1 h-px bg-system-outline-variant',
        header: 'block py-2 px-4 text-system-on-surface bg-system-surface',
        hidden: 'invisible opacity-0',
        item: {
            container: 'list-none',
            base:
                'flex bg-system-surface items-center justify-start py-2 px-4 cursor-pointer w-full ' +
                'text-system-on-surface ' +
                'hover:primary-hover-state active:primary-active-state ',
            icon: 'mr-2 h-4 w-4',
        },
        style: {
            dark: '',
            light: '',
            auto: 'rounded-lg mt-1 bg-system-surface shadow-md',
        },
        target: 'w-fit p-0',
    },
    inlineWrapper: 'flex items-center p-0',
};

/** `dropdownTheme` with the panel flush to its trigger: for menus that should sit on the row that opened them. */
export const flushDropdownTheme: FlowbiteDropdownTheme = {
    ...dropdownTheme,
    floating: {
        ...dropdownTheme.floating,
        style: {
            ...dropdownTheme.floating.style,
            auto: 'rounded-lg mt-[0px] bg-system-surface shadow-md',
        },
    },
};
